<template>
  <select class="form-control" :value="value" v-on:change="$emit('input', $event.target.value)" :name="name">
    <option value="" v-if="empty == true"></option>
    <option v-for="item in items" :value="item.id" :key="item.id" :selected="item.id == value">
      {{ item.name }}
    </option>
  </select>
</template>

<script>
  export default {
    props:{
      value: String,
      items: Array, 
      empty: Boolean,
      name: String
    }
  }
</script>

<style scoped>

</style>